module.exports = __webpack_public_path__ + "e7797436ccd2dc0cc50611f4c153e2a2.png";